<template>
  <div>
    <div class="row">
      <div class="col-md-12"></div>
    </div>

    <div class="row">
      <div class="col-12 col-md-6 mb-3"><span
        class="is-bold ">{{ $t("leads.table.created_at") }}:</span> {{ selectedLead.createdAt | localTime }}
      </div>
      <div v-if="selectedLead.phone" class="col-12 col-md-6 mb-3"><span
        class="is-bold ">{{ $t("references.inputs.mobile_phone") }}:</span> {{ selectedLead.phone }}
      </div>
      <div class="col-12 col-md-6 mb-3"><span class="is-bold">Email:</span> {{ selectedLead.email || "N/A" }}</div>
      <div
        v-if="selectedLead.addressLine1 || selectedLead.addressLine2 || selectedLead.addressCity"
        class="col-12 col-md-6 mb-3">
        <span class="is-bold">{{ $t("leads.details.address") }}:</span>
        {{ selectedLead.addressLine1 }}<span
        v-if="selectedLead.addressLine1 && (selectedLead.addressLine2)">, </span>
        {{ selectedLead.addressLine2 }}<span
        v-if="selectedLead.addressLine2 && (selectedLead.addressCity)">, </span>
        {{ selectedLead.addressCity }}
      </div>
      <div v-if="selectedLead.birthdate" class="col-12 col-md-6 mb-3"><span
        class="is-bold">{{ $t("leads.details.birthdate") }}: </span>{{ birthdate }}
      </div>
      <div v-if="selectedLead.addressCity" class="col-12 col-md-6 mb-3"><span
        class="is-bold">{{ $t("leads.details.city") }}:</span> {{ selectedLead.addressCity }}
      </div>

      <div v-if="selectedLead.genderInternalObj" class="col-12 col-md-6 mb-3"><span
        class="is-bold">{{ $t("wellbeing.leads.gender") }}:</span> {{ $t(selectedLead.genderInternalObj.translate) }}
      </div>

      <div v-if="selectedLead.appointmentPreferenceInternalObj" class="col-12 col-md-6 mb-3"><span
        class="is-bold">{{ $t("wellbeing.appointmentPreferences.title") }}:</span> {{ $t(selectedLead.appointmentPreferenceInternalObj.translate) }}
      </div>

      <div v-if="selectedLead.entity" class="col-12 col-md-6 mb-3"><span
        class="is-bold">{{ $t("leads.table.entity") }}:</span> {{ selectedLead.entity.name }}
      </div>
      <br />
      <br />
      <div v-if="selectedLead.privacyPolicy" class="col-md-12">
            <span class="clickable" @click.prevent="$emit('openPrivacyPolicyModal', {})">
              <span class="clickable is-bold">{{ $t("leads.details.privacy_policy") }} </span>
              <i class="px-1 fa fa-external-link"></i>
            </span>
      </div>
    </div>

    <br>
    <div class="row" v-if="selectedLead.comments">
      <div class="col-md-12" v-if="selectedLead.comments"><span
        class="is-bold">{{ $t("leads.details.observations") }}:</span> {{ selectedLead.comments }}
      </div>
    </div>

    <br />
    <hr class="separator-lead-details">
    <!-- Simptoms -->
    <div>
      <h4> {{ $t("wellbeing.leads.simptoms") }}</h4>
      <div v-if="selectedLead.simptomsInternalObj.length > 0">
        <li v-for="item in selectedLead.simptomsInternalObj">
          {{ $t(item.translate) }}
        </li>
      </div>
      <span v-else>
        N/A
      </span>
    </div>


  </div>
</template>

<script>
import CurrentLocaleMixin from "@/mixins/CurrentLocaleMixin";
import { mapGetters } from "vuex";

export default {
  props: {
    selectedLead: {
      type: Object,
      required: true
    }
  },
  mixins: [
    CurrentLocaleMixin
  ],
  created() {
    if(this.selectedLead.gender) {
      this.selectedLead.genderInternalObj = this.genderOptions.filter(opt => opt.value === this.selectedLead.gender)[0]
    }
    if(this.selectedLead.appointmentPreference) {
      this.selectedLead.appointmentPreferenceInternalObj = this.appointmentPreferences.filter(pref => pref.id === parseInt(this.selectedLead.appointmentPreference.id))[0]
    }
    if(this.selectedLead.simptoms) {
      this.selectedLead.simptomsInternalObj = this.simptomsOptions.filter(opt => this.selectedLead.simptoms.some(elem => parseInt(elem.id) === opt.id ))
    }

  },
  data() {
    return {};
  },
  methods: {},
  computed: {
    ...mapGetters({
      appointmentPreferences: "wellbeing/appointmentPreferences",
      simptomsOptions: "wellbeing/simptomsOptions",
      genderOptions: "wellbeing/genderOptions"
    }),
    birthdate: function() {
      if (this.isWebLead) {
        let created = this.moment(this.selectedLead.created_at, "YYYY-MM-DD");
        let date = this.moment(this.selectedLead.birthdate, "DD/MM/YYYY");
        let total = created.diff(date, "years", true);
        let val = total < 18 ? "< 18" : total <= 29 ? "18 - 29" : total <= 49 ? "30 - 49" : total < 65 ? "50 - 65" : "> 65";
        return val;
      }
      return this.selectedLead.birthdate;
    },

    leadHeader: function() {
      let header = "";
      if (this.selectedLead && this.selectedLead.title && this.selectedLead.name && this.selectedLead.surname) {
        header = this.selectedLead.title + " " + this.selectedLead.name + " " + this.selectedLead.surname;
      } else if (this.selectedLead && this.selectedLead.name && this.selectedLead.surname) {
        header = this.selectedLead.name + " " + this.selectedLead.surname;
      } else if (this.selectedLead && this.selectedLead.name) {
        header = this.selectedLead.name;
      }
      return header;
    }
  }
};
</script>
